if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.variantIdInput.disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');
        this.submitButtonText = this.submitButton.querySelector('span');
        this.upsellVariantId = this.dataset.upsellVariantId;
        this.redirectToCheckout = this.dataset.redirectToCheckout === 'true';


        if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

        this.hideErrors = this.dataset.hideErrors === 'true';
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        this.handleErrorMessage();

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        this.querySelector('.loading__spinner').classList.remove('hidden');

        const formData = new FormData(this.form);
        if (this.cart) {
          formData.append(
            'sections',
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }
        const config = this.getCartAddConfig(formData);

       
        // Optimized: Direct cart addition for faster performance
        // Removed sequential cart checks and upsell logic that cause delays
          //       fetch(`${routes.cart_url}.js`)
          // .then((response) => response.json())
          // .then((cartState) => {
          //   if (cartState.item_count === 0 && this.upsellVariantId) {
          //     return fetch(`${routes.cart_add_url}`, this.getUpsellProductConfig());
          //   }
          // })
          // .then(() => {
          //   return fetch(`${routes.cart_add_url}`, config);
          // })
        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);

              const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
              if (!soldOutMessage) return;
              this.submitButton.setAttribute('aria-disabled', true);
              this.submitButtonText.classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
            } else if (this.redirectToCheckout) {
              window.location = '/checkout';
              return;
            } else if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            if (!this.error)
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                cartData: response,
              });
            this.error = false;
            const quickAddModal = this.closest('quick-add-modal');
            if (quickAddModal) {
              document.body.addEventListener(
                'modalClosed',
                () => {
                  setTimeout(() => {
                    // COMMENTED OUT: Using third-party cart drawer app instead of native cart drawer
                    // this.cart.renderContents(response);
                  });
                },
                { once: true }
              );
              quickAddModal.hide(true);
            } else {
              // COMMENTED OUT: Using third-party cart drawer app instead of native cart drawer
              // this.cart.renderContents(response);
            }
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.submitButton.classList.remove('loading');
            if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
            if (!this.error) this.submitButton.removeAttribute('aria-disabled');
            this.querySelector('.loading__spinner').classList.add('hidden');
          });
      }


      getCartAddConfig(formData) {
        const mainItem = this.getMainLineItem(formData);
        const addOnItems = this.getSelectedAddOnItems(mainItem.quantity);

        if (!addOnItems.length) {
          const config = fetchConfig('javascript');
          config.headers['X-Requested-With'] = 'XMLHttpRequest';
          delete config.headers['Content-Type'];
          config.body = formData;
          return config;
        }

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';

        const payload = {
          items: [mainItem, ...addOnItems],
        };

        if (this.cart) {
          payload.sections = this.cart.getSectionsToRender().map((section) => section.id);
          payload.sections_url = window.location.pathname;
        }

        config.body = JSON.stringify(payload);
        return config;
      }

      getMainLineItem(formData) {
        const item = {
          id: formData.get('id'),
          quantity: this.getLineItemQuantity(formData.get('quantity')),
        };

        const properties = {};

        formData.forEach((value, key) => {
          if (!value) return;
          if (['id', 'quantity', 'form_type', 'utf8', 'product-id', 'section-id', 'sections', 'sections_url'].includes(key)) {
            return;
          }

          if (key === 'selling_plan') {
            item.selling_plan = value;
            return;
          }

          const propertyMatch = key.match(/^properties\[(.+)\]$/);
          if (propertyMatch) {
            properties[propertyMatch[1]] = value;
          }
        });

        if (Object.keys(properties).length) {
          item.properties = properties;
        }

        return item;
      }

      getSelectedAddOnItems(mainQuantity) {
        return this.getAddOnBlocks()
          .map((block) => {
            const toggle = block.querySelector('[data-product-addon-toggle]');
            const variantId = block.dataset.variantId;

            if (!toggle || toggle.disabled || !toggle.checked || !variantId) return null;

            return {
              id: variantId,
              quantity: mainQuantity,
              properties: {
                _addon: 'true',
                _addon_source: 'product_info',
              },
            };
          })
          .filter(Boolean);
      }

      getAddOnBlocks() {
        return Array.from(this.closest('product-info')?.querySelectorAll('[data-product-addon-block]') || []);
      }

      getLineItemQuantity(quantityValue) {
        const quantity = Number(quantityValue);
        return Number.isFinite(quantity) && quantity > 0 ? quantity : 1;
      }

            getUpsellProductConfig() {
        const upsellFormData = new FormData();
        upsellFormData.append('id', this.upsellVariantId);
        upsellFormData.append('quantity', 1);

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];
        config.body = upsellFormData;

        return config;
      }


      
      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }

      toggleSubmitButton(disable = true, text) {
        if (disable) {
          this.submitButton.setAttribute('disabled', 'disabled');
          if (text) this.submitButtonText.textContent = text;
        } else {
          this.submitButton.removeAttribute('disabled');
          this.submitButtonText.textContent = window.variantStrings.addToCart;
        }
      }

      get variantIdInput() {
        return this.form.querySelector('[name=id]');
      }
    }
  );
}
